import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getBranches = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/branches', {
        params,
        withCredentials: true
    });
    return res;
}

export const createBranch = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/branches',
    createObj,
    {
        withCredentials: true,
        successMessage: "สาขาได้ถูกสร้างแล้ว"
    });
    return res;
}

export const updateBranch = async (id, updateObj) => {
    const res = await axios.put(BACKEND_URL+`/branches/${id}`,
    updateObj,
    {
        withCredentials: true,
        successMessage: "สาขาได้ถูกแก้ไขแล้ว"
    });
    return res;
}

export const deleteBranch = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/branches/${id}`,
    {
        withCredentials: true,
        successMessage: "สาขาได้ถูกลบแล้ว"
    });
    return res;
}

export const restoreBranch = async (id) => {
    const res = await axios.post(BACKEND_URL+`/branches/${id}/restore`,
    {},
    {
        withCredentials: true,
        successMessage: "สาขาได้ถูกกู้คืนแล้ว"
    });
    return res;
}

export const listBranchProducts = async (id) => {
    const res = await axios.get(BACKEND_URL+`/branches/${id}/products`,
    {
        withCredentials: true
    });
    return res;
}

export const addBranchProduct = async (id, productId) => {
    const res = await axios.post(BACKEND_URL+`/branches/${id}/products`,
    {
        product: productId
    },
    {
        withCredentials: true,
        successMessage: "สินค้าได้ถูกเพิ่มเข้าสาขาแล้ว"
    });
    return res;
}

export const removeBranchProduct = async (id, productId) => {
    const res = await axios.post(BACKEND_URL+`/branches/${id}/remove_product`,
    {
        product: productId
    },
    {
        withCredentials: true,
        successMessage: "สินค้าได้ถูกลบออกจากสาขาแล้ว"
    });
    return res;
}

export const setBranchProduct = async (id, productIds) => {
    const res = await axios.post(BACKEND_URL+`/branches/${id}/update_product`,
    {
        products: productIds
    },
    {
        withCredentials: true,
        successMessage: "สินค้าได้ถูกอัพเดตเข้าสาขาแล้ว",
        showSuccessMessage: false
    });
    return res;
}